import { createContext } from 'react'

export const defaultHeader = 0 // HOME
                                  
const HeaderContext = createContext({header:defaultHeader, setHeader: () => {}}) 

export default HeaderContext